/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinishWriteRequest
 */
export interface FinishWriteRequest {
    /**
     * 
     * @type {number}
     * @memberof FinishWriteRequest
     */
    fileCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FinishWriteRequest
     */
    complete?: boolean;
}

/**
 * Check if a given object implements the FinishWriteRequest interface.
 */
export function instanceOfFinishWriteRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FinishWriteRequestFromJSON(json: any): FinishWriteRequest {
    return FinishWriteRequestFromJSONTyped(json, false);
}

export function FinishWriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinishWriteRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileCount': !exists(json, 'file_count') ? undefined : json['file_count'],
        'complete': !exists(json, 'complete') ? undefined : json['complete'],
    };
}

export function FinishWriteRequestToJSON(value?: FinishWriteRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_count': value.fileCount,
        'complete': value.complete,
    };
}

